export const GRID_LAYOUT_COLS = { sm: 24, xxs: 2 } as const;

export const GRID_LAYOUT_SMALL_BREAKPOINT = 'sm' as const;

export const GRID_ITEM_HEIGHT = 6;

export const EMPTY_PANEL_GROUP_TITLE = 'Panel Group';
